// extracted by mini-css-extract-plugin
export default {"panel":"SubpageSelection_panel__OlD5X","buttonToSubPages":"SubpageSelection_buttonToSubPages__1IENh","active":"SubpageSelection_active__uy5AX"};